module.exports = __webpack_public_path__ + "static/media/Test54.ead47bd8.bmp";